import Vue from 'vue';
import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import { createGoal, deleteGoal, fetchGoals, fetchGoal, updateGoal } from './goals.utils';

const goals = {
    namespaced: true,
    state: {
        error: {},
        map: {},
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setMapAtKey (state, { key, goal }) {
            Vue.set(state.map, [key], goal);
        },
        deleteMapAtKey (state, { key }) {
            Vue.delete(state.map, key);
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async loadAll ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            try {
                const goalsList = await fetchGoals();
                commit('setMap', { map: keyBy(goalsList, 'id') });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async loadOne ({ commit, state }, { reFetch = false, id } = {}) {
            if (state.map[id] && !reFetch) {
                return;
            }

            try {
                const goal = await fetchGoal({ id });
                commit('setMapAtKey', { key: id, goal });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async create ({ commit }, { goal }) {
            try {
                const newGoal = await createGoal({ goal });
                commit('setMapAtKey', { key: newGoal.id, goal: newGoal });

                return newGoal;
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async update ({ commit }, { goal }) {
            try {
                const updatedGoal = await updateGoal({ goal });
                commit('setMapAtKey', { key: updatedGoal.id, goal: updatedGoal });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async delete ({ commit }, { id }) {
            try {
                await deleteGoal({ id });
                commit('deleteMapAtKey', { key: id });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
    },
    getters: {
        goalById: (state) => (id) => state.map[id],
        list: (state) => values(state.map),
        listForTargetIdAndType: (state) => ({ targetId, targetType }) => {
            const goals = values(state.map);

            return goals
                .filter((goal) => goal.targetId === targetId && goal.targetType === targetType)
                .sort((a, b) => b.createdAt - a.createdAt);
        },
    },
};

export default goals;
